import React from 'react';
import PropTypes from 'prop-types';

import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import styles from './WarningNote.module.scss';

const getNote = (inventoryLimit) => {
  if (inventoryLimit === 0)
    return ['This item is sold out', 'Please remove it'];
  return [
    `Only ${inventoryLimit} of this item ${
      inventoryLimit === 1 ? 'is' : 'are'
    } available`,
    'Please update quantity',
  ];
};

const WarningNote = ({
  inventoryLimit,
  disabledButton,
  style,
  onClickButton,
}) => {
  const note = getNote(inventoryLimit);

  return (
    <div className={styles.container} style={style}>
      <div className={styles.content}>
        <div className={styles.leftContent}>
          <i className="far fa-exclamation-circle" />
          <p>
            {note[0]}
            {'. '}
            <Button
              buttonType={BUTTON_TYPES.PRIMARY}
              className={styles.button}
              disabled={disabledButton}
              onClick={onClickButton}
            >
              {note[1]}
            </Button>
            {'.'}
          </p>
        </div>
      </div>
    </div>
  );
};

WarningNote.propTypes = {
  inventoryLimit: PropTypes.number.isRequired,
  disabledButton: PropTypes.bool.isRequired,
  style: PropTypes.shape({}),
  onClickButton: PropTypes.func.isRequired,
};

WarningNote.defaultProps = {
  style: {},
};

export default WarningNote;
